/* eslint-disable */
export default{
  install (Vue, options) {
    Vue.prototype.getData = function (constName) {
      return eval(constName)
    }
  }
}
// *********************************   定义各常量的值   ****************************** //
//                  初始化方法： 在组件中初始化时，定义变量接受全局VUE                 //
//                  方法中使用： this.别名.getData('常量名')                           //
// *********************************************************************************** //

/* ************************************ 操作的URL地址 start ****************************** */
// 登录URL
const LOGIN_URL = 'login'
// 退出登录URL
const LOGOUT_URL = 'logout'
// 获取全部权限URL
const GET_ALL_PERMISSION_URL = 'permission/allPermissionList'
// 获取菜单资源详情URL
const GET_MENU_INFO_URL = 'permission/menuInfo'
// 更新菜单资源详情URL
const UPDATE_MENU_INFO_URL = 'permission/updateMenu'
// 删除菜单资源详情URL
const DEL_MENU_URL = 'permission/delMenu'
// 新增菜单资源
const ADD_MENU_URL = 'permission/addMenu'
// 获取角色列表
const GET_ROLE_LIST_URL = 'permission/roleList'
// 获取角色和权限详情
const GET_ROLE_PERMISSION_DETAIL_URL = 'permission/roleAndPermissionInfo'
// 新增或修改角色信息和权限
const EDIT_OR_CREATE_ROLE_URL = 'permission/editCreateRole'
// 删除角色信息
const DEL_ROLE_INFO_URL = 'permission/delRoleInfo'
// 获取用户管理列表
const USER_MANAGEMENT_LIST_URL = 'permission/getUserManagementList'
// 获取用户基本信息
const GET_USER_BASE_INFO = 'user/getUserBaseInfo'
// 修改用户基本信息
const EDIT_USER_BASE_INFO_URL = 'user/editUserBaseInfo'
// 模糊查询业务员信息
const FUZZY_QUERY_SALE_LIST_URL = 'sale/fuzzyQuerySaleInfo'
// 获取医院名称和id列表
const GET_HOSPITAL_NAME_ID_LIST = 'hospital/getHospitalNameIdList'
// 获取公司名称和id列表
const GET_COMPANY_NAME_ID_LIST = 'company/companyNameAndId'
// 获取PMs医院名称和id列表
const GET_HOSPITAL_NAME_ID_LIST_FROM_PMS = 'synchro/getHospitalNameIdListFromPms'
// 查询用户名或手机号是否已经存在
const IS_EXIST_USERNAME_OR_PHONE_URL = 'user/isExistUser'
// 管理员注册用户
const ADMIN_REGISTER_USER_URL = 'register/adminRegisterUser'
// 获取订单列表
const GET_OERDER_LIST = 'order/getPcOrderList'
// 删除订单
const DELETE_ORDER_URL = 'order/delPcOrder'
// 根据订单id获取订单详情
const GET_ORDER_DETAIL_URL = 'order/orderDetailData'
// 根据订单id 查询订单表详细信息
const GET_ORDER_DETAIL_INFO_URL = 'order/orderDetailInfo'
// 修改订单信息
const EDIT_ORDER_URL = 'order/updateOrderByOrderId'
// 审核通过最终报告
const PASS_ORDER_FINAL_REPORT_AUDIT_URL = 'order/passOrderFinalReportAudit'
// 审核eps通过最终报告
const PASS_ORDER_EPS_REPORT_AUDIT_URL = 'esophagus/passOrderEpsReportAudit'
// 审核不通过最终报告
const REFUSE_ORDER_FINAL_REPORT_AUDIT_URL = 'order/refuseOrderFinalReportAudit'
// 审核eps不通过最终报告
const REFUSE_EPS_FINAL_REPORT_AUDIT_URL = 'esophagus/refuseEpsFinalReportAudit'
// 诊断报告上传成功后修改订单状态和更新报告链接
const UPDATE_ORDER_AND_EPS_ORDER_AND_SN_STATUS = 'esophagus/updateOrderAndEpsOrderAndSnStatus'
// 转移订单
const ORDER_TRANSFER = 'order/orderTransfer'
/* ************************************ 新闻管理 start ****************************** */
const GET_POINT_LIST = 'point/getPointList'
const GET_NEW_LIST_URL = 'news/getNewsList'
const SAVE_NEWS_INFO_URL = 'news/saveNews'
const DELETE_NEWS_URL = 'news/deleteNews'
const UPDATE_NEWS_URL = 'news/updateNews'
const GET_NEWS_INFO_BY_NEW_ID_URL = 'news/getNewsInfoByNewId'
/* ************************************ 新闻管理 end ****************************** */
/* ************************************ 会议管理 start ****************************** */
const SAVE_MEETING_URL = 'meeting/saveMeeting'
const DELETE_MEETING_URL = 'meeting/deleteMeeting'
const UPDATE_MEETING_URL = 'meeting/updateMeeting'
const GET_MEETING_LIST_URL = 'meeting/getMeetingList'
const GET_MEETING_INFO_BY_MEETING_ID_URL = 'meeting/getMeetingInfoByMeetingId'
/* ************************************ 会议管理 end ****************************** */
/* ************************************ 疑难分享 start ****************************** */
const SAVE_SHARING_URL = 'sharing/saveSharing'
const DELETE_SHARING_URL = 'sharing/deleteSharing'
const UPDATE_SHARING_URL = 'sharing/updateSharing'
const GET_SHARING_INFO_BY_SHARINGID_URL = 'sharing/getSharingInfoBySharingId'
const GET_SHARING_LIST_URL = 'sharing/getSharingList'
/* ************************************ 疑难分享 end ****************************** */

/* ************************************ 人员管理的URL地址 start ****************************** */
// 获取病人列表URL
const GET_PATIENT_LIST_URL = 'patient/getPatientList'
// 获取病人基本信息URL
const GET_PATIENT_INFO_DETAIL_URL = 'patient/getPatientInfoDetail'
// 查询当前用户下的绑定的打印员信息
const GET_EXISTS_PATIENT_PRINTER_LIST = 'patient/getExistsPatientPrinterList'
// 保存病人基本信息URL
const SAVE_PATIENT_INFO_URL = 'patient/savePatientInfo'
// 删除患者记录URL
const DEL_PATIENT_URL = 'patient/delPatient'
// 获取病人账单详情URL
const GET_PATIENT_ORDER_DETAIL_URL = 'patient/getPatientOrderDetail'
// 获取打印员列表病人信息URL
const GET_PRINTER_LIST_URL = 'patient/getPatientPrinterList'
// 获取打印员病人信息URL
const GET_PRINTER_DETAIL_URL = 'patient/changePrinter'
// 修改打印员绑定状态
const change_printer_status = 'patient/'
// 获取门诊医生列表URL
const GET_OUT_DOCTOR_LIST_URL = 'outdoctor/getOutDoctorList'
// 获取门诊医生基本信息URL
const GET_OUT_DOCTOR_INFO_DETAIL_URL = 'outdoctor/getOutDoctorInfoDetail'
// 保存门诊医生基本信息URL
const SAVE_OUT_DOCTOR_INFO_URL = 'outdoctor/saveOutDoctorInfo'
// 修改门诊医生状态URL
const UPDATE_OUT_DOCTOR_STATUS_URL = 'outdoctor/updateOutDoctorStatus'
// 删除门诊医生记录URL
const DEL_OUT_DOCTOR_URL = 'outdoctor/delOutDoctor'
// 获取门诊医生医院相关信息URL
const GET_OUT_DOCTOR_HOSPITAL_DETAIL_URL = 'outdoctor/getOutDoctorHospitalDetail'
// 获取门诊医生订单信息URL
const GET_OUT_DOCTOR_ORDER_DETAIL_URL = 'outdoctor/getOutDoctorOrderDetail'
// 获取诊断专家列表URL
const GET_EXPERT_LIST_URL = 'expert/getExpertPcList'
// 获取诊断专家信息URL
const GET_EXPERT_INFO_DETAIL_URL = 'expert/getExpertInfoDetail'
// 保存诊断专家信息URL
const SAVE_EXPERT_INFO_URL = 'expert/saveExpertInfo'
// 删除诊断专家记录URL
const DEL_EXPERT_URL = 'expert/delExpert'
// 获取诊断专家图文信息
const GET_EXPERT_PIC_DETAIL_URL = 'expert/getExpertPicDetail'
// 上传诊断专家图文
const UPLOAD_EXPERT_PIC_URL = 'expert/uploadExpertPic'
// 获取诊断专家医院信息URL
const GET_EXPERT_HOSPITAL_DETAIL_URL = 'expert/getExpertHospitalDetail'
// 获取诊断专家订单信息URL
const GET_EXPERT_ORDER_DETAIL_URL = 'expert/getExpertOrderDetail'
// 获取销售人员列表信息URL
const GET_SALE_LIST_URL = 'sale/getSaleList'
// 获取销售人员信息URL
const GET_SALE_INFO_DETAIL_URL = 'sale/getSaleInfoDetail'
// 保存销售人员信息URL
const SAVE_SALE_INFO_URL = 'sale/saveSaleInfo'
// 删除销售人员记录URL
const DEL_SALE_URL = 'sale/delSale'
// 获取销售人员公司信息
const GET_SALE_COMPANY_DETAIL_URL = 'sale/getSaleCompanyDetail'
// 获取销售人员直属门诊医生记录URL
const GET_SALE_DOCTOR_DETAIL_URL = 'sale/getSaleDoctorDetail'
// 获取销售人员附属销售人员记录
const GET_SALE_SUBSIDIARY_SALE_DETAIL_URL = 'sale/getSaleSubsidiarySaleDetail'
// 获得医院列表URL
const GET_HOSPITAL_LIST_URL = 'hospital/getHospitalList'
// 获取公司列表URL
const GET_COMPANY_LIST_URL = 'company/getCompanyList'
// 获取门诊医生基本信息
const GET_OUT_DOCTOR_INFO_URL = 'outdoctor/docInfo'
// 获取业务员基本信息
const GET_SALE_BASE_INFO_URL = 'sale/saleBaseInfo'
/* ************************************ 人员管理的URL地址 end ****************************** */

/* ************************************ 同步数据的URL地址 start ****************************** */
// 获取pms系统中的诊断专家信息
const GET_PMS_EXPERT_URL = 'synchro/getPmsExpert'
// 同步pms系统中的诊断专家信息
const SYNCHRO_EXPERT_URL = 'synchro/synchroExpert'
// 获取pms系统中的医院信息
const GET_PMS_HOSPITAL_URL = 'synchro/getPmsHospital'
// 同步pms系统中的医院信息
const SYNCHRO_HOSPITAL_URL = 'synchro/synchroHospital'
// 刷新专家列表
const SYNC_REFRESH_EXPERT_URL = 'synchro/refreshExpert'
/* ************************************ 同步数据的URL地址 end ****************************** */

/* ************************************ 分成管理 start ****************************** */
// 分成规则列表
const SHARE_RULE_LIST_URL = 'share/shareRuleList'
// 更新分成规则
const UPDATE_SHARE_RULE_URL = 'share/updateShareRule'
// 获取提现申请列表
const CASH_WITHDRAW_LIST_URL = 'transaction/cashWithdrawList'
// 获取提现详情
const GET_CASE_WITHDRAW_DETAIL_URL = 'transaction/withdrawDtl'
// 管理员获取资金明细列表
const GET_FUNDS_DETAIL_LIST_URL = 'transaction/fundsDtl'
// 通过提现申请
const PASS_CASH_WITHDRAW_URL = 'transaction/passCashWithdraw'
// 拒绝提现申请
const REFUSE_CASH_WITHDRAW_URL = 'transaction/refuseCashWithdraw'
// 完成转账
const COMPLETE_TRANSFER_URL = 'transaction/completeTransfer'
/* ************************************ 分成管理 end ****************************** */

/* ************************************ 机构管理 start ****************************** */
// 新增医院
const SAVE_HOSPITAL_INFO_URL = 'hospital/saveHospitalInfo'
// 根据医院id删除医院
const DEL_HOSPITAL_INFO_URL = 'hospital/delHospitalInfo'
// 根据医院id修改医院基本信息
const EDIT_HOSPITAL_BASE_INFO_URL = 'hospital/editHospitalBaseInfo'
// 机构管理获取医院列表
const GET_ALL_HOSPITAL_LIST = 'hospital/getAllHospitalList'
// 根据医院ID查询医院基本信息
const GET_HOSPITAL_BASE_INFO = 'hospital/getHospitalBaseInfo'
// 判断医院是否已经存在
const IS_EXIST_HOSPITAL_NAME_URL = 'hospital/isExistHospitalByName'
// 机构管理获取公司列表
const GET_ALL_COMPANY_LIST_URL = 'company/getAllCompanyList'
// 添加公司信息
const SAVE_COMPANY_INFO_URL = 'company/saveCompanyInfo'
// 根据公司id删除公司信息
const DEL_COMPANY_INFO_URL = 'company/delCompanyInfo'
// 修改公司基本信息
const EDIT_COMPANY_BASE_INFO_URL = 'company/editCompanyBaseInfo'
// 根据公司id查询公司信息
const GET_COMPANY_BASE_INFO_URL = 'company/getCompanyInfo'
// 判断公司是否存在
const IS_EXIST_COMPANY_NAME_URL = 'company/isExistCompanyByName'
// 获取实验室站点列表
const GET_LABORATORY_LIST_URL = 'lab/getLaboratoryList'
// 新增实验室站点
const SAVE_LABORATORY_INFO_URL = 'lab/saveLaboratoryInfo'
// 根据实验室站点id，获取实验室信息
const GET_LABORATORY_INFO_URL = 'lab/getLaboratoryInfo'
// 判断实验室站点是否已经存在
const IS_EXIST_LABORATORY_NAME_URL = 'lab/isExistLaboratoryName'
// 修改实验室站点信息
const UPDATE_LABORATORY_INFO_URL = 'lab/updateLaboratoryInfo'
// 修改实验室站点信息
const DELETE_LABORATORY_INFO_URL = 'lab/deleteLaboratoryInfo'
/* ************************************ 机构管理 end ****************************** */

/* ************************************ 食道筛查 start ****************************** */
// 获取食道筛订单列表
const GET_ESOPHAGUS_ORDER_LIST = 'esophagus/getEsophagusOrderList'
// 根据食道筛订单Id 查询食道筛订单详情
const GET_ESOPHAGUS_ORDER_DETAIL_INFO_URL = 'esophagus/getEsophagusOrderDetailInfo'
// 根据食道筛订单Id 修改食道筛订单详情
const EDIT_ESOPHAGUS_ORDER_URL = 'esophagus/editEsophagusOrder'
// 根据 order_id 查询 食道筛产品序列号
const GET_ESOPHAGUS_SEQUENCE_URL = 'esophagus/getEsophagusSequenceList'
// 数据修复仅限用于购买后没有进行取货或者取货后绑定失败的情况下进行操作
const GET_DATA_RECOVERY_URL = 'esophagus/dataRecovery'
// 根据 order_id进行退款
const GET_REFUND = 'wxPay/refund'
// 获取待配货订单列表
const GET_ESOPHAGUS_PENDING_ORDER_LIST_URL = 'esophagus/getEsophagusPendingOrderList'
// 获取已经打印的二维码列表（二维码管理） -----------------------------------------------------------------
const GET_QR_CODE_LIST_URL = 'esophagus/getQRCodeList'
// 添加食道筛产品序列号
const ADD_SERIAL_NUMBER_URL = 'esophagus/addSerialNumber'
// 添加二维码信息
const ADD_QR_CODE_NUMBER = 'esophagus/addQRCodeNumber'
// 删除二维码信息
const DELETE_QRCODE_URL = 'esophagus/delQRCode'
// 获取食道筛订单待出库列表
const GET_OUTBOUND_ORDER_LIST_URL = 'esophagus/getOutboundOrderList'
// 实现出库操作
const OUTBOUND_OPERATION_URL = 'esophagus/outboundOperation'
// 提交推送列表的订单信息和检测人信息
const SAVE_PUSH_ORDERINFO = 'order/createOrderInfo'
// 提交病人和订单信息
const SAVE_ESOPHAGUS_ORDER = 'esophagus/saveEsophagusOrder'
// 获取待入库产品列表
const GET_PRODUCT_STORAGE_LIST_URL = 'eps/getProductStorageList'
// 获取顺丰路由信息
const GETEPSSFROUNTLIST_URL = 'eps/getEpsSfRountList'
// 取消顺丰订单
const CANCELSFORDER_URL = 'eps/cancelSfOrder'
// 实现产品入库操作
const EPS_SN_IN_STORAGE_URL = 'eps/epsSnInStorage'
// 获取产品列表
const GET_PRODUCT_LIST_URL = 'eps/getProductList'
// 获取产品详情
const GET_EPS_SN_DETAIL_URL = 'eps/getEpsSnDetail'
// 修改产品信息
const EDIT_EPS_SN_URL = 'eps/editEpsSn'
// 获取待寄回产品列表
const GET_AWAIT_BACK_PRODUCT_LIST_URL = 'eps/getAwaitBackProductList'
// 修改产品寄回站点
const EDIT_EPS_LAB_URL = 'eps/editEpsLab'
// 获取产品列表
const GET_LAB_NAME_ID_LIST_URL = 'lab/getLaboratoryIdNameIdList'
// 根据实验室id获取产品列表
const GET_LAB_INFO_URL = 'lab/getLabInfo'
// 生成产品序列号
const GET_PRODUCT_CODE = 'esophagus/getProductCode'
// 生成二维码信息
const CREATE_QR_CODE = 'esophagus/createQRCode'
// 从pms系统中获取病例
const GET_CASE_LIST_FROM_PMS = 'synchro/getCaseListFromPms'
// 根据订单id获取食康列表
const GET_EPS_SN_LIST_BY_ORDER_ID = 'eps/getEpsSnListByOrderId'
// 审核并推送报告
const PUSH_CASE_EPS_REPORT = 'eps/pushCaseEpsReport'
// 订单绑定病例
const BIND_CASE_ORDER_ID = 'synchro/bindCaseOrderId'

/* ************************************ 食道筛查 end ****************************** */

/* ************************************ 字典表的URL地址 start ****************************** */
// 获取用户状态字典信息
const GET_USER_STATUS_DIC_LIST = 'dic/dicUserStatus'
// 获取医生学位
const GET_DOCTOR_DEGREE_DIC_LIST = 'dic/dicDoctorDegree'
// 获取医生职称
const GET_DOCTOR_TITLE_DIC_LIST = 'dic/dicDoctorTitle'
// 获取所有角色列表
const GET_ALL_SYS_ROLE_LIST = 'dic/dicSysRole'
// 获取医院等级列表
const GET_HOSPITAL_DEGREE_LIST = 'dic/dicHospitalDegree'
// 获取积分状态列表
const GET_ALL_POINT_STATUS_LIST = 'dic/dicPointStatus'
// 获取积分操作类型列表
const GET_ALL_POINT_HANDLE_TYPE_LIST = 'dic/dicHandleType'
// 获取医院状态字典列表
const GET_HOSPITAL_STATUS_LIST = 'dic/dicHospitalStatus'
// 获取提现状态字典列表
const GET_WITHDRAW_STATUS_DIC_LIST = 'dic/dicWithdrawStatus'
// 获取医生状态字典列表
const GET_DOCTOR_STATUS_DIC_LIST = 'dic/dicDoctorStatus'
// 获取订单状态字典列表
const GET_ORDER_STATUS_DIC_LIST = 'dic/dicOrderStatus'
// 获取订单病理类型字典表
const GET_ORDER_PATHOLOGY_TYPE_DIC_LIST = 'dic/dicOrderPathologyType'
// 获取食道筛订单状态
const GET_ESOPHAGUS_STATUS_DIC_LIST = 'dic/dicEpsStatus'
// 获取食道筛订单来源
const GET_ESOPHAGUS_FROM_DIC_LIST = 'dic/dicEpsFrom'
// 获取食康一号创建人的列表
const GET_CREATE_USER_LIST = 'user/CreateUsersFromList'
// 获取售卖机的集合
const GET_SELL_MACHINE_LIST = 'tellerMac/getSellMacList'
// 获取虚拟配货所需的售卖机的集合
const GET_VIR_MAC_LIST = 'tellerMac/getVirMacList'
// 获取虚拟订单的列表
const GET_VIRTUAL_ORDER_LIST = 'order/getVirtualOrderList'
//删除虚拟订单
const DELETE_VIRTUAL_ORDER = 'order/deleteVirtualOrder'
// 新增虚拟订单
const ADD_VIRTUAL_ORDER_INFO = 'order/createVirtualOrder'
// 获取食康一号检测者信息
const GET_TESTER_INFO = 'user/getTesterInfo'
// 获取食道筛产品状态
const GET_EPS_SN_STATUS_DIC_LIST = 'dic/dicEpsSnStatus'
// 获取快递付款方式
const GET_EXPRESS_PAY_METHOD_DIC_LIST = 'dic/dicExpressPayMethod'
// 获取快递单位
const GET_EXPRESS_DIC_LIST = 'dic/dicExpress'
// 获取收货方式
const GET_RECEIVING_TYPE_DIC_LIST = 'dic/dicReceivingType'
// 获取怡早学订单详情记录类型字典表
const GET_RECORD_TYPE_DIC_LIST = 'dic/dicRecordType'
/* ************************************ 字典表的URL地址 start ****************************** */

/* ************************************ 操作的URL地址 end ****************************** */

/* ************************************ 商品的URL地址 start ****************************** */
// 获取商品列表
const GET_EPS_PRODUCT_LIST = 'product/webGetProductList'
// 获取商品详情
const GET_EPS_PRODUCT_DETAIL = 'product/getProductDetail'
// 修改商品信息
const UPDATE_EPS_PRODUCT_INFO_URL = 'product/updateEpsProductInfo'
// 新增商品信息
const SAVE_EPS_PRODUCT_INFO_URL = 'product/addEpsProductInfo'


/* ************************************ 商品的URL地址 end ****************************** */
/* ************************************ 柜员机管理URL地址 start ****************************** */
// 获取柜员机的列表
const GET_TELLER_MACHINE_LIST_URL = 'tellerMac/getMacList'
// 新增柜员机信息
const ADD_TELLER_MACHINE_URL = 'tellerMac/addTellerMac'
// 新增柜员机微信二维码
const ADD_MACHINE_QRCODE_URL = 'tellerMac/getMachineQrcode'
// 删除柜员机
const DEL_TELLER_MACHINE_URL = 'tellerMac/delTellerMac'
// 修改柜员机信息
const UPDATE_TELLER_MACHINE_URL = 'tellerMac/editTellerMac'
// 根据ID查询柜员机信息
const GET_TELLER_MACHINE_URL = 'tellerMac/getTellerMachine'
// 根据柜员机id 获取柜员机的销售详情
const GET_TELLER_MAC_SALES_DETAILS_URL = 'tellerMachineDetailRecord/getTellerMacSalesDetails'
// 查询售出，回收，补货，取货数量
const GET_STATISTICS_DATA_URL = 'tellerMachineDetailRecord/getStatisticsData'
/* ************************************ 柜员机管理URL地址 end ****************************** */

/* ************************************ 代理商管理URL地址 end ****************************** */
// 获取代理商列表
const GET_LIST_AGENT_URL = 'agentInfo/getListAgent'
// 新增代理商
const ADD_AGENT_URL = 'agentInfo/addAgent'
// 删除代理商
const DELETE_AGENT_INFO_URL = 'agentInfo/deleteAgentInfo'
// 修改代理商
const UPDATE_AGENT_URL = 'agentInfo/updateAgent'
// 根据Id获取代理商信息
const GET_AGENT_BY_AGENCY_ID_URL = 'agentInfo/getAgentByAgencyId'
// 根据代理商绑定自助机的Id删除绑定的自助机
const DELETE_AGENT_BINDING_TELLER_MAC_URL = 'agentTellerMacRelation/deleteAgentBindingTellerMac'
// 根据代理商绑定自助机的Id修改价格
const EDIT_TELLER_MAC_PRICE_URL = 'agentTellerMacRelation/updateTellerMacPrice'
// 根据代理商id,查询代理商绑定的自助机列表
const GET_AGENT_BINDING_TELLER_MAC_LIST_URL = 'agentTellerMacRelation/getAgentBindingTellerMacListByAgencyId'
// 查询未被绑定的柜员机集合
const GET_UNBOUND_EQUIPMENT_LIST_URL = 'agentTellerMacRelation/getUnboundEquipmentList'
// 绑定多个设备
const BINDING_MORE_EQUIPMENT_URL = 'agentTellerMacRelation/bindingMoreEquipment'
// 绑定设备
const BINDING_EQUIPMENT_URL = 'agentTellerMacRelation/bindingEquipment'
// 根据手机号查询需要被绑定用户
const GET_UNBOUND_USER_LIST_URL = 'agentBindAdmin/getUserListByPhone'
// 代理商指定管理员
const AGENT_BIND_ADMIN_URL = 'agentBindAdmin/agentBindAdmin'
// 查询代理商已经绑定用户列表
const GET_BOUNDING_USER_LIST_URL = 'agentBindAdmin/getBoundingUserList'
// 删除代理商绑定用户
const DELETE_AGENT_BOUNDING_ADMIN_URL = 'agentBindAdmin/deleteAgentBoundingAdmin'
// 查询推广员列表
const GET_PROMOTER_LIST_URL = 'promoterInfo/getPromoteList'
// 查询代理商列表，用于下拉查询
const GET_AGENT_LIST_URL = 'agentInfo/getAgentList'
// 根据推广员id查询推广员详情
const GET_PROMOTER_BY_ID_URL = 'promoterInfo/getPromoterByPromoterId'
// 根据推广员id查询推广员详情
const UPDATE_PROMOTER_BY_ID_URL = 'promoterInfo/updatePromoterById'
// 根据推广员id删除推广员
const DELETE_PROMOTER_BY_ID_URL = 'promoterInfo/deletePromoterById'

/* ************************************ 代理商管理URL地址 end ****************************** */

/* ********************************* 优惠券管理 start ***************************** */
// 获取优惠券的列表信息
const GET_COUPON_LIST_URL = 'coupon/getCouponList'
// 获取代理商的信息集合
const GET_AGENT_LIST_INFO_URL = 'agentInfo/getAgentInfoList'
// 保存新增的优惠券信息
const ADD_COUPON_INFO_URL = 'coupon/addCoupon'
// 删除优惠券
const EDIT_COUPON_URL = 'coupon/editCoupon'
// 根据ID获取优惠券信息
const GET_COUPON_BY_ID_URL = 'coupon/getCouponById'
// 查询订单使用指定优惠券信息
const GET_COUPON_BINDING_ORDER_LIST_URL = 'coupon/getOrderInfoById'
/* ********************************* 优惠券管理 end ***************************** */

/* ********************************* 统计报表 start ***************************** */
// 查询订单报表相关数据
const GET_REPORT_DATA_URL = 'order/getReportData'
// 根据订单id,查询订单金额分成详情列表
const GET_ORDER_AMOUNT_DETAIL_LIST_URL = 'orderAmountDetail/getOrderAmountDetailListByOrderId'

/* ********************************* 统计报表 end ***************************** */

/* ********************************* 健康档案 start ***************************** */
// 获取病人列表(健康档案)
const GET_PATIENT_RECORD_LIST_URL = 'healthy/getPatientList'
// 删除病人的健康档案信息
const DEL_PATIENT_RECORD_URL = 'healthy/delPatientRecord'
// 新增病人信息
const ADD_PATIENT_INFO_URL = 'healthy/addPatientInfo'
// 获取患者的信息
const GET_PATIENT_INFO_BY_ID_URL = 'healthy/getPatientInfoById'
// 保存问卷调查信息
const SAVE_HEALTH_RECORDS_URL = 'healthy/saveHealthRecords'
/* ********************************* 健康档案 end ***************************** */

/* ********************************* 对接微信公众号 start ***************************** */
// 获取微信菜单列表
const GET_WECHAT_MENU_LIST_URL = 'wxMenu/getWechatMenuList'
// 根据微信ID，菜单列，菜单行获取菜单信息
const GET_WX_MENU_INFO_URL = 'wxMenu/getWxMenuInfo'
// 保存并发布微信菜单
const SAVE_AND_PUBLISH_URL = 'wxMenu/saveWxMenuConf'
// 修改并发布微信菜单
const EDIT_WX_MENU_CONF_URL = 'wxMenu/editWxMenuConf'
// 删除微信菜单
const DELETE_WX_MENU_CONF_URL = 'wxMenu/deleteWxMenuConf'
// 发布微信菜单
const PUBLISH_WECHAT_MENU_URL = 'wxMenu/publishWechatMenu'
// 获取微信远端模板列表
const GET_TEMPLATE_LIST_URL = 'wxTemplateInfo/getTemplateList'
// 同步微信模板
const SAVE_TEMPLATE_INFO_URL = 'wxTemplateInfo/saveTemplateInfo'
// 修改微信模板
const EDIT_TEMPLATE_INFO_URL = 'wxTemplateInfo/editTemplateInfo'
// 获取微信模板ID列表
const GET_TEMPLATE_ID_LIST_BY_WX_ID_URL = 'wxTemplateInfo/getTemplateIdListByWxId'
// 从数据库中获取微信模板列表
const GET_TEMPLATE_INFO_LIST_URL = 'wxTemplateInfo/getTemplateInfoList'
// 从数据库中删除微信模板
const DELETE_TEMPLATE_INFO_BY_TEMPLATE_NO_URL = 'wxTemplateInfo/deleteTemplateInfoByTemplateNo'
// 获取模板参数列表
const GET_TEMPLATE_PARAM_LIST_URL = 'wxTemplateParam/getTemplateParamList'
// 修改模板参数颜色
const EDIT_TEMPLATE_PARAM_COLOR_URL = 'wxTemplateParam/editTemplateParamColor'
// 删除模板参数
const DELETE_TEMPLATE_PARAM_URL = 'wxTemplateParam/deleteTemplateParam'

/* ********************************* 对接微信公众号 end ***************************** */

/* ********************************* 微信管理 start ***************************** */
// 获取微信列表
const GET_WEIXIN_LIST_URL = 'wx/getWeixinList'
// 保存微信信息
const SAVE_WEIXIN_URL = 'wx/saveWeiXin'
// 获取ID获取微信信息
const GET_WEIXINBYID_URL = 'wx/getWeixinById'
/* ********************************* 健康档案 end ***************************** */
/* ********************************* 统计员管理 start ***************************** */
// 查询用户所绑定的设备名称
const GET_TELLER_BIND_ADMIN_LIST = 'tellerUser/getTellerBindAdminList'
// 根据用户ID获取已经绑定的设备信息
const GET_TELLER_BIND_ADMIN_BY_USER_ID = 'tellerUser/getTellerBindAdminByUserId'
// 添加设备绑定子管理员
const SAVE_TELLER_ADMIN = 'tellerUser/saveTellerAdmin'
/* ********************************* 统计员管理 end ***************************** */

/* ********************************* 腾讯地图API start ***************************** */
// 获取小程序角色列表
const GET_MP_ROLE_LIST_URL = 'mpRole/getMpRoleList'
// 根据id获取角色信息
const GET_MP_ROLE_BYID_URL = 'mpRole/getMpRoleById'
// 保存小程序角色
const SAVE_MP_ROLE_URL = 'mpRole/saveMpRole'
// 根据id删除角色信息
const DEL_MP_ROLE_BYID_URL = 'mpRole/delMpRoleById'
// 获取小程序用户列表
const GET_MP_USER_LIST_URL = 'mpUser/getMpUserList'
// 根据id获取用户信息
const GET_MP_USER_BYID_URL = 'mpUser/getMpUserById'
// 保存小程序用户
const SAVE_MP_USER_URL = 'mpUser/saveMpUser'
// 根据id删除用户信息
const DEL_MP_USER_BYID_URL = 'mpUser/delMpUserById'
/* ********************************* 腾讯地图API end ***************************** */

// 查询送检单信息列表
const GET_INSPECTION_LIST_URL = 'inspection/getInspectionListPc'
// 查询检测信息列表
const GET_INSPECTION_PARAM_LIST_URL = 'inspectionParam/getInspectionParamList'
// 删除检测信息
const DELETE_INSPECTION_PARAM_URL = 'inspectionParam/deleteInspectionParam'
// 根据id获取送检单信息
const GET_INSPECTION_BY_ID_URL = 'inspection/getInspectionById'
// 修改送检单信息
const UPDATE_INSPECTION_INFO_URL = 'inspection/updateInspectionInfo'

// 修改检测信息
const EDIT_ORDER_NUM_BY_ID_URL = 'inspectionParam/editOrderNumById'
/* ********************************* 发货管理 start ***************************** */
// 获取出货单的列表
const GET_DELIVER_LIST_BY_CONDITION = 'delivery/getDeliveryByConditions'
// 获取指定出货单的信息
const GET_DELIVERY_INFO_BY_ID = 'delivery/getDeliveryInfoById'
// 修改并上传快递图片
const UPDATE_COURIER_URL = 'delivery/updateCourierUrl'
//修改运送的信息
const UPDATE_DELIVERY_INFO_BY_ID = 'delivery/updateDeliveryInfoById'
/* ********************************* 发货管理 end ***************************** */

// 获取病例数据中心列表
const  GET_CASE_DATA_LIST = 'caseData/caseDataList'
// 根据病例ID获取玻片信息
const  GET_SLIDELAYER_BY_CASE_ID = 'caseData/getSlideLayerByCaseId'
// 根据病例细胞信息
const  GET_CROP_LIST = 'caseData/getCropList'
/* ********************************* 卡包管理 stard ***************************** */
// 添加主卡信息
const ADD_CARD_URL = 'card/addCard'
// 根据主卡id修改主卡信息
const GET_CARD_BY_CARD_ID_URL = 'card/getCardByCardId'
// 修改主卡信息
const UPDATE_CARD_URL = 'card/updateCard'
// 查询卡列表
const GET_CARD_LIST_URL = 'card/getCardList'
// 绑定主卡
const SAVE_CARD_INFO_URL = 'cardInfo/saveCardInfo'
// 查询绑定主卡的信息列表
const GET_CARD_INFO_LIST_BY_CARD_ID_URL = 'cardInfo/getCardInfoListByCardId'
// 查询绑定主卡的信息
const GET_CARD_INFO_BY_CARD_INFO_ID_URL = 'cardInfo/getCardInfoByCardInfoId'
// 修改绑定主卡信息
const UPDATE_CARD_INFO_URL = 'cardInfo/updateCardInfo'
// 批量添加主卡信息
const BULK_ADD_CARD_URL = 'card/saveCardBatch'
// 查询卡包出售配置列表
const GET_CARD_ORDER_CONFIG_LIST_URL = 'cardOrderConfig/getCardOrderConfigList'
// 新增卡包出售配置
const ADD_CARD_ORDER_CONFIG_URL = 'cardOrderConfig/addCardOrderConfig'
// 删除卡包出售配置
const DELETE_CARD_ORDER_CONFIG_URL = 'cardOrderConfig/deleteCardOrderConfig'
// 修改卡包出售配置
const UPDATE_CARD_ORDER_CONFIG_URL = 'cardOrderConfig/updateCardOrderConfig'
// 根据id获取卡包出售配置
const GET_CARD_ORDER_CONFIG_BY_ID_URL = 'cardOrderConfig/getCardOrderConfigById'
/* ********************************* 卡包管理 end ***************************** */
/* ************************************ 分账管理 start ****************************** */
// 获取需要分账的订单信息
const GET_PROFIT_SHARING_ORDER_LIST = 'profitSharing/getProfitSharingOrderList'
// 获取需要分账的详细信息
const GET_PROFIT_SHARING_ORDERD_ETAIL_LIST = 'profitSharing/getProfitSharingOrderDetailList'
// 获取需要分账接收方的详细信息
const GET_PROFIT_SHARING_ORDER_USER_LIST = 'profitSharing/getProfitSharingOrderUserList'
// 请求分账
const GET_PROFIT_SHARING_ORDERS = 'profitSharing/getProfitSharingOrders'
// 查询分账结果
const GET_PROFIT_SHARING_RESULTS = 'profitSharing/getProfitSharingResults'
// 查询分账结果
const GET_PROFIT_SHARING_UNFREEZE_ORDERS = 'profitSharing/getProfitSharingUnfreezeOrders'
// 查询利润分享的用户列表
const GET_PROFIT_SHARING_USER_LIST = 'profitSharingUser/getProfitSharingUserList'
// 删除利润分享的用户
const DELETE_PROFIT_SHARING_USER = 'profitSharingUser/deleteProfitSharingUser'
// 获取分账接收方类型
const GET_RECIPIENT_TYPE_LIST = 'profitSharingUser/getRecipientTypeList'
// 获取与分账方的关系类型
const GET_RELATION_TYPE_LIST = 'profitSharingUser/getRelationTypeList'
// 获取微信列表
const GET_WX_INFO_LIST = 'profitSharingUser/getWxInfoList'
// 添加分账用户
const SAVE_PROFIT_SHARING_USER = 'profitSharingUser/saveProfitSharingUser'
// 根据昵称和手机号查询微信用户信息
const GET_OPEN_ID_BY_NICK_NAME_OR_PHONE = 'profitSharingUser/getOpenIdByNickNameOrPhone'
// 根据openId和wxId获取分账用户信息
const IS_EXIST_PROFIT_SHARING_USER = 'profitSharingUser/isExistProfitSharingUser'
/* ************************************ 分账管理 end ****************************** */
// 医院登录报告系统查询报告
const GET_EPSSNCASEREPORT_BY_USERID = 'eps/getEpsSnCaseReportByUserId'
// 库存管理
const GET_BOX_LIST = 'boxes/getBoxList'
const DEL_BOX_BY_ID = 'boxes/delBoxById'
// 获取产品信息
const GET_PRODUCT_LIST = 'products/getProductList'
const DEL_PRODUCT_BY_ID = 'products/delProductIdById'
// 获取发货信息
const GET_SHIPMENT_LIST = 'shipments/getShipmentList'
const DEL_SHIPMENT_BY_ID = 'shipments/delShipmentById'

// 设备管理相关常量
export const CREATE_DEVICE_URL = 'esoDevices/createDevice'
export const UPDATE_DEVICE_URL = 'esoDevices/updateDevice'
export const DELETE_DEVICE_URL = 'esoDevices/deleteDevice'
export const GET_DEVICE_LIST_URL = 'esoDevices/getDeviceList'
export const GET_DEVICE_BY_ID_URL = 'esoDevices/getDeviceById'

// 库存管理相关常量
export const CREATE_INVENTORY_URL = 'esoInventory/createInventory'
export const UPDATE_INVENTORY_URL = 'esoInventory/updateInventory'
export const DELETE_INVENTORY_URL = 'esoInventory/deleteInventory'
export const GET_INVENTORY_LIST_URL = 'esoInventory/getInventoryList'
export const GET_INVENTORY_BY_ID_URL = 'esoInventory/getInventoryById'

// 产品类型管理相关常量
export const CREATE_PRODUCT_TYPE_URL = 'esoProductTypes/createProductType'
export const UPDATE_PRODUCT_TYPE_URL = 'esoProductTypes/updateProductType'
export const DELETE_PRODUCT_TYPE_URL = 'esoProductTypes/deleteProductType'
export const GET_PRODUCT_TYPES_LIST_URL = 'esoProductTypes/getProductTypeList'
export const GET_PRODUCT_TYPE_BY_ID_URL = 'esoProductTypes/getProductTypeById'

// 二维码管理相关常量
export const CREATE_QR_CODE_URL = 'esoQrCodes/createQrCode'
export const UPDATE_QR_CODE_URL = 'esoQrCodes/updateQrCode'
export const DELETE_QR_CODE_URL = 'esoQrCodes/deleteQrCode'
export const GET_QR_CODES_LIST_URL = 'esoQrCodes/getQrCodeList'
export const GET_QR_CODE_BY_ID_URL = 'esoQrCodes/getQrCodeById'

// 试剂管理相关常量
export const CREATE_REAGENT_URL = 'esoReagents/createReagent'
export const UPDATE_REAGENT_URL = 'esoReagents/updateReagent'
export const DELETE_REAGENT_URL = 'esoReagents/deleteReagent'
export const GET_REAGENTS_LIST_URL = 'esoReagents/getReagentList'
export const GET_REAGENT_BY_ID_URL = 'esoReagents/getReagentById'
export const GET_AVAILABLE_DEVICES_URL = 'esoDevices/getAvailableDevices'
// 历史记录管理相关常量
export const GET_HISTORY_RECORDS_LIST_URL = 'esoHistoryRecords/getHistoryRecordList'

/* ************************************ 申请发货管理 start ****************************** */
export const GET_PURCHASE_AGENT_LIST_URL = '/purchase/agent/selectPage'
export const DELETE_PURCHASE_AGENT_URL = '/purchase/agent/removeById'
export const GET_PURCHASE_AGENT_BY_ID_URL = '/purchase/agent/getById'

/* ************************************ 申请发货管理 end ****************************** */



// WEBPACK FOOTER //
// ./src/utils/WpcConst.js